/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import App from 'apmui/App';
import EventTags from 'apmui/EventTags';
import { RECAPTCHA_FIELD_NAME } from './Model';
import { INPUT } from 'apmui/components/form/Model';
import { findField } from 'apmui/common/modelAPI';
import GetPRPQuery from 'apmui/util/GetPRPQuery';

/* Enable default event chain for forms */
import 'apmui/components/form/Controller';

const app = App.get();

/* Import Clint Login Controllers */
import './Validations';
import './EdgeClientController';

app.subscribeDefault(EventTags.CONFIGURE, (event, store) => {
    if (store.pageType !== 'logon') {
        return;
    }
    const form = store.logon.form;

    if (form && store.logon.recaptcha) {
        if (!form.fields) {
            form.fields = [];
        }
        if (!findField(form, RECAPTCHA_FIELD_NAME)) {
            form.fields.push({
                name: RECAPTCHA_FIELD_NAME,
                type: INPUT.HIDDEN,
                caption: '',
                disabled: false,
                value: undefined,
            });
        }
    }

    if (form && store.logon.original) {
        /* Set correct form action if we are in per-request AP */
        const query = GetPRPQuery();
        if (query) {
            form.action = '/subsession_logon_submit.php3?' + query;
        }
    }
});
